module.exports = __webpack_public_path__ + "img/home1.ccc4fa76.jpg";